// SPDX-License-Identifier: AGPL-3.0-or-later

import * as UserSettingsCommands from '@app/features/user/commands/UserSettingsCommands';
import {PushSettings} from '@app/features/user/components/modals/tabs/notifications_tab/PushSettings';
import UserSettings from '@app/features/user/state/UserSettings';
import {observer} from 'mobx-react-lite';

export const PushInactiveTimeoutControl = observer(() => {
	const handleAfkTimeoutChange = async (value: number) => {
		try {
			await UserSettingsCommands.update({afkTimeout: value * 60});
		} catch {}
	};
	return (
		<PushSettings
			afkTimeout={UserSettings.afkTimeout}
			onAfkTimeoutChange={handleAfkTimeoutChange}
			showHeader={false}
			data-flx="user.advanced-settings-tab.push-inactive-timeout"
		/>
	);
});
